import axios from 'axios';
import { notification } from 'antd';

import { BASE_URL } from '@configs/authConfig';
import { getAccessToken, removeAccessToken, setAccessToken } from '@pages/auth/handleToken';
import { IS_DEV } from '@src/constants/config';
import { ErrorCode } from '@src/errors/errorCode';

const seathruApi = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
});

seathruApi.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();

    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

seathruApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    const prevRequest = config;

    if (IS_DEV && response?.data?.message) {
      notification.error({ message: response?.data?.message });
    }

    prevRequest.sent = true;
    if (response?.status === 403 && !prevRequest?.sent) {
      prevRequest.sent = true;

      setAccessToken(response.data?.data?.access_token);
      prevRequest.headers.Authorization = `Bearer ${response.data?.data?.access_token}`;
      return seathruApi(prevRequest);
    }

    if (response?.status === 401) {
      const error_code = response.data?.error_code;
      removeAccessToken();
      if (error_code === ErrorCode.INVALID_AUTO_RECORD) return Promise.reject(error);
      window.location.href = 'process.env.REACT_APP_SEATHRU_URL';
    }

    return Promise.reject(error);
  },
);

export default seathruApi;
